export var PathKey;
(function (PathKey) {
    PathKey["Id"] = "Id";
    PathKey["TenantId"] = "TenantId";
    PathKey["FileName"] = "FileName";
    PathKey["PublishDate"] = "PublishedToInsightDateTime";
    PathKey["ResourceId"] = "ResourceId";
    PathKey["MetadataType"] = "MetadataType";
    PathKey["Manager"] = "Manager";
    PathKey["Fund"] = "Fund";
    PathKey["Investor"] = "InvestorAccounts";
    PathKey["DocumentCategory"] = "DocumentCategory";
    PathKey["ReferenceDate"] = "ReferenceDate";
    PathKey["DownloadDate"] = "DownloadDate";
    PathKey["ReceivedDate"] = "ReceivedDate";
    PathKey["Audited"] = "Audited";
    PathKey["Template"] = "Template";
    PathKey["DueDate"] = "DueDate";
    PathKey["MetadataModificationDate"] = "MetadataModificationDate";
})(PathKey || (PathKey = {}));
